import { c as _c } from "react/compiler-runtime";
import React from "react";
import DropPartMarkdown from "./DropPartMarkdown";
import DropListItemContentMedia from "../item/content/media/DropListItemContentMedia";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ApiDropGroupMention } from "@/generated/models/ApiDropGroupMention";
import type { MentionedWave } from "@/entities/IDrop";
import type { ApiDropReferencedNFT } from "@/generated/models/ApiDropReferencedNFT";
interface DropPartContentProps {
  readonly mentionedUsers: ApiDropMentionedUser[];
  readonly mentionedGroups?: ApiDropGroupMention[] | undefined;
  readonly mentionedWaves: MentionedWave[];
  readonly referencedNfts: ApiDropReferencedNFT[];
  readonly partContent: string | null;
  readonly onQuoteClick: (drop: any) => void;
  readonly currentDropId?: string | undefined;
  readonly partMedias: Array<{
    mimeType: string;
    mediaSrc: string;
  }>;
  readonly currentPartCount: number;
}
const DropPartContent: React.FC<DropPartContentProps> = t0 => {
  const $ = _c(17);
  const {
    mentionedUsers,
    mentionedGroups: t1,
    mentionedWaves,
    referencedNfts,
    partContent,
    onQuoteClick,
    currentDropId,
    partMedias,
    currentPartCount
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const mentionedGroups = t2;
  let t3;
  if ($[2] !== currentDropId || $[3] !== mentionedGroups || $[4] !== mentionedUsers || $[5] !== mentionedWaves || $[6] !== onQuoteClick || $[7] !== partContent || $[8] !== referencedNfts) {
    t3 = <div className="tw-group"><DropPartMarkdown mentionedUsers={mentionedUsers} mentionedGroups={mentionedGroups} mentionedWaves={mentionedWaves} referencedNfts={referencedNfts} partContent={partContent} onQuoteClick={onQuoteClick} currentDropId={currentDropId} /></div>;
    $[2] = currentDropId;
    $[3] = mentionedGroups;
    $[4] = mentionedUsers;
    $[5] = mentionedWaves;
    $[6] = onQuoteClick;
    $[7] = partContent;
    $[8] = referencedNfts;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== currentPartCount || $[11] !== partContent || $[12] !== partMedias) {
    t4 = !!partMedias.length && <div className={`${partContent ? "tw-mt-4" : "tw-mt-1"} tw-space-y-2`}>{partMedias.map((media, i) => <div key={`part-${currentPartCount}-media-${i}-${media.mediaSrc}`} className="tw-h-64"><DropListItemContentMedia media_mime_type={media.mimeType} media_url={media.mediaSrc} /></div>)}</div>;
    $[10] = currentPartCount;
    $[11] = partContent;
    $[12] = partMedias;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t3 || $[15] !== t4) {
    t5 = <div className="tw-h-full tw-w-full">{t3}{t4}</div>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export default DropPartContent;